

























































































import TinymceEditor from '@/components/TinymceEditor.vue'
import { Component, Vue } from 'vue-property-decorator'
import { findArticleByTitle, findArticleById, findArticleByType, findAllArticle, createArticle, updateArticle, removeArticle } from '@/api/articles'

@Component({
  name: 'Article',
  components: {
    TinymceEditor
  },
  filters: {
    parseTime: (timestamp: string) => {
      return new Date(timestamp).toLocaleString()
    }
  }
})
export default class extends Vue {
  private paging = {
    page: 1, // 当前所处分页
    limit: 10, // 页面条数
    total: 10 // 总数量
  }
  private listLoading = true
  private selectValue = 'all' // 选择框value
  private searchValue = ''    // 搜索框value
  private handleType = 'add'  // add代表新增，edit代表编辑
  private articleList = []  // 文章列表
  private articleDialog: Boolean = false
  private articleInfo = {   // 文章内容
    id: '',   
    url: '',
    type: '1', 
    image: '',
    title: '',
    summary: '',
    create_date: ''
  }
  private FormRules = {
    title: [
      {required: true, message: '请输入标题', trigger: 'blur'}
    ],
    type: [
      {required: true, message: '请选择类型', trigger: 'blur'}
    ]
  }


  created() {
    // 数据初始化
    this.init()
  }

  // 初始化界面
  private init() {
    this.getAllArticle()
  }
  
  // 设置当前所处分页
  private handleCurrentChange(val: number) {
    this.paging.page = val
    this.getAllArticle()
  }
  // 设置页面条数
  private handleSizeChange(val: number) {
    this.paging.limit = val
    this.getAllArticle()
  }

  // 上传图片
  private beforeIconUpload(file:any) {
    var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
    const rigthType = 'jpg jpeg png'.includes(testmsg);
    const isLt3M = file.size;
    if (!rigthType) {
      this.$message({ message: '上传文件只能是 jpg、jpeg、png格式!', type: 'warning' });
      (this.$refs.uploadImg as any).clearFiles();
    }
    if (isLt3M > 1024 * 1024 * 3) {
      this.$message({ message: '上传文件大小不能超过 3MB!', type: 'warning' });
      (this.$refs.uploadImg as any).clearFiles();
    }
    return rigthType && isLt3M
  }

  // 新增文章
  private handleAdd() {
    this.resetForm()
    this.handleType = 'add'
    this.articleDialog = true; 
    this.selectValue = '1'
  }
  // 编辑文章
  private handleEdit(index: number, row: any) {
    this.$refs.uploadImg && (this.$refs.uploadImg as any).clearFiles();
    this.handleType = 'edti'
    this.articleDialog = true; 
    row.type = String(row.type)
    this.articleInfo = row 
  }
  // 确认表单
  private confirmForm() {
    (this.$refs.articleInfo as any).validate((valid:boolean) => {
      if (valid) {
        this.handleType==='add' ? this.addArticle() : this.editArticle();
      } else {
        return false;
      }
    });
  }

  // 重置表单
  private resetForm() {
    this.$nextTick(() => {
      this.articleInfo = {   // 文章内容
        id: '',   
        url: '',
        type: '1', 
        image: '',
        title: '',
        summary: '',
        create_date: ''
      }
      this.$refs.uploadImg && (this.$refs.uploadImg as any).clearFiles();
    })
  }

  // 删除文章
  private handleDelete(index: number, row: any) {
    this.$confirm('是否删除该文章?', '提示', { type: 'warning' })
      .then(() => {
        this.deleteArticleById(index, row)  // 删除文章
      }).catch(() => {
        this.$message({ type: 'info', message: '已取消删除' });          
      });
  }
  
  
  private async addArticle() {
    const formData = new FormData();
    const icon = (this.$refs.uploadImg as any).uploadFiles[0];
    if(icon) {
      formData.append('icon', icon.raw);
    }
    formData.append('url', this.articleInfo.url);
    formData.append('title', this.articleInfo.title);
    formData.append('type', this.articleInfo.type);
    formData.append('summary', this.articleInfo.summary);
    const { data, code } = await createArticle(formData)
    if(code===200) {
      this.getAllArticle()
      this.articleDialog = false
    }
  }
  private async editArticle() {
    const formData = new FormData();
    const icon = (this.$refs.uploadImg as any).uploadFiles[0];
    if(icon) {
      formData.append('icon', icon.raw);
    }
    formData.append('id', this.articleInfo.id);
    formData.append('url', this.articleInfo.url);
    formData.append('title', this.articleInfo.title);
    formData.append('type', this.articleInfo.type);
    formData.append('summary', this.articleInfo.summary);
    const { data, code } = await updateArticle(formData)
    if(code===200) {
      this.getAllArticle()
      this.articleDialog = false
    }
  }
  private async deleteArticleById(index: number, row: any) {
    const { data, code } = await removeArticle({id: row.id})
    if(code===200) {
      this.getAllArticle()
      this.articleDialog = false
    }
  }

  private async getArticleByTitle() {
    this.listLoading = true
    const { data } = await findArticleByTitle({title: this.searchValue})
    this.articleList = data
    this.paging.total = data.length // 更新分页数据
    setTimeout(() => { this.listLoading = false }, 0.5 * 1000)
  }

  private async getArticleByType(value: string) {
    if(value=='all') return this.getAllArticle()
    this.listLoading = true
    const { data } = await findArticleByType({type: value}) // 查找所有类型为文件的菜单
    this.articleList = data
    this.paging.total = data.length // 更新分页数据
    setTimeout(() => { this.listLoading = false }, 0.5 * 1000)
  }

  private async getAllArticle() {
    this.listLoading = true
    const { data } = await findAllArticle(this.paging)
    this.articleList = data.rows
    this.paging.total = data.count // 更新分页数据
    setTimeout(() => { this.listLoading = false }, 0.5 * 1000)
  }

}
